import {Checkout} from '@wix/ambassador-checkout/types'

export const isFreeOrder = (checkout: Checkout) => {
  return Number(checkout.priceSummary!.total!.amount) === 0
}
